<template>
  <a
    ref="manageCookiesRef"
    href="#"
    :class="[className, 'cookiebot-button']"
    @click="handleCookiebotClick"
  >
    {{ label }}
  </a>
</template>

<script>
import { ref, onMounted, onUnmounted } from 'vue';

export default {
  name: 'CookiebotButton',
  props: {
    label: {
      type: String,
      default: 'Filter',
    },
    className: {
      type: String,
      default: '',
      required: false,
    },
  },

  setup() {
    const manageCookiesRef = ref(null);

    const isWidthAboveThreshold = () => window.innerWidth > 992;

    const getCookiebotWidget = () => {
      const cookiebotWidget = document.getElementById('CookiebotWidget');
      const cookiebotWidgetButton = document.querySelector(
        '.CookiebotWidget-logo',
      );

      return {
        cookiebotWidget,
        cookiebotWidgetButton,
      };
    };

    const updateWidgetPosition = () => {
      const { cookiebotWidget } = getCookiebotWidget();
      if (!cookiebotWidget || !manageCookiesRef.value) return;

      if (isWidthAboveThreshold()) {
        const right = manageCookiesRef.value.getBoundingClientRect().right;
        const bottom = manageCookiesRef.value.getBoundingClientRect().bottom;

        const horizontalPosition = `right: calc(100vw - ${Math.floor(
          right,
        )}px); left: unset;`;
        const verticalPosition = `bottom: calc(100vh - ${Math.floor(
          bottom,
        )}px + 1rem);`;
        const styleValue = `${horizontalPosition} ${verticalPosition}; position: fixed;`;

        cookiebotWidget.setAttribute('style', styleValue);
      } else {
        cookiebotWidget.setAttribute('style', '');
      }
    };

    const handleCookiebotClick = e => {
      e.preventDefault();
      window.alreadyOpened = true;
      const { cookiebotWidget, cookiebotWidgetButton } = getCookiebotWidget();
      if (!cookiebotWidget) return;

      updateWidgetPosition();
      cookiebotWidgetButton?.click();
    };

    const makeInputDisabled = () => {
      if (isWidthAboveThreshold()) {
        const inputDisabled = document.getElementById(
          'CybotCookiebotDialogBodyLevelButtonNecessary',
        );

        if (inputDisabled) {
          inputDisabled.setAttribute('disabled', '');
        }
      }
    };

    const handleResize = () => {
      updateWidgetPosition();
      makeInputDisabled();
    };

    onMounted(() => {
      window.addEventListener('resize', handleResize);
    });

    onUnmounted(() => {
      window.removeEventListener('resize', handleResize);
    });

    return {
      manageCookiesRef,
      handleCookiebotClick,
    };
  },
};
</script>
